{
  "completed": "Concluído: ",
  "current": "Atual: ",
  "notCompleted": "Não concluído: ",
  "steplist": "Lista de passos"
}
